import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import MapContainer from '../components/MapContainer';
import { Container, Spinner, Alert, Navbar } from 'react-bootstrap';

const SharePage = () => {
  const location = useLocation();
  const [mapParams, setMapParams] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const params: any = {};
    searchParams.forEach((value, key) => {
      if (key === 'collection_ids') {
        params.selectedRows = value.split(',');
      } else if (key === 'campaign_id') {
        params.campaignId = value;
      } else if (key === 'geopolygon') {
        try {
          params.geopolygon = JSON.parse(value);
        } catch (e) {
          console.error('Failed to parse geopolygon:', e);
        }
      } else if (key === 'center') {
        const [lat, lng] = value.split(',').map(parseFloat);
        if (!isNaN(lat) && !isNaN(lng)) {
          params.center = [lat, lng];
        }
      } else if (key === 'zoom') {
        const zoom = parseFloat(value);
        if (!isNaN(zoom)) {
          params.zoom = zoom;
        }
      } else if (key === 'tilt') {
        const tilt = parseFloat(value);
        if (!isNaN(tilt)) {
          params.tilt = tilt;
        }
      } else if (key === 'bearing') {
        const bearing = parseFloat(value);
        if (!isNaN(bearing)) {
          params.bearing = bearing;
        }
      } else {
        params[key] = value;
      }
    });
    setMapParams(params);
    setLoading(false);
  }, [location.search]);

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (!mapParams || (!mapParams.selectedRows && !mapParams.campaignId)) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">
          Invalid share link. Missing required parameters.
        </Alert>
      </Container>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <Navbar bg="light" expand="lg" className="p-2" style={{ flexShrink: 0 }}>
        <Container fluid>
          <Navbar.Brand>SigCap Map Visualization</Navbar.Brand>
          <div className="ms-auto d-flex align-items-center">
            <a
              href="https://people.cs.uchicago.edu/~muhiqbalcr/sigcap/"
              target="_blank"
              rel="noopener noreferrer"
              className="me-3"
              style={{ fontSize: '0.9rem' }}
            >
              About SigCap
            </a>
            <a
              href="/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ fontSize: '0.9rem' }}
            >
              SigCap Data Platform
            </a>
          </div>
        </Container>
      </Navbar>
      <div style={{ flex: '1 1 auto', overflow: 'hidden' }}>
        <MapContainer
          selectedRows={mapParams.selectedRows}
          campaignId={mapParams.campaignId}
          selectedNetworkType={mapParams.network_type || 'cellular'}
          center={
            mapParams.center ||
            (mapParams.geopolygon &&
            mapParams.geopolygon[0] &&
            mapParams.geopolygon[0].length >= 2
              ? [mapParams.geopolygon[0][1], mapParams.geopolygon[0][0]]
              : [41.759103, -87.1])
          }
          zoom={mapParams.zoom || 10}
          width="100%"
          height="100%"
          isEmbedded={true}
          preventInitialFit={!!(mapParams.center && mapParams.zoom)}
          technology={mapParams.technology}
          band={mapParams.band}
          statistic={mapParams.statistic}
          binSize={mapParams.bin_size}
          operator={mapParams.operator}
          geopolygon={mapParams.geopolygon}
          baseLayer={mapParams.base_layer}
          tilt={mapParams.tilt}
          bearing={mapParams.bearing}
          showOperatorControl={mapParams.show_operator_control !== 'false'}
          showTechnologyControl={mapParams.show_technology_control !== 'false'}
          showBandControl={mapParams.show_band_control !== 'false'}
          showStatisticControl={mapParams.show_statistic_control !== 'false'}
          showBinSizeControl={mapParams.show_bin_size_control !== 'false'}
        />
      </div>
    </div>
  );
};

export default SharePage;
